import { render, staticRenderFns } from "./UserItemPage.vue?vue&type=template&id=c1fb77ea&"
import script from "./UserItemPage.vue?vue&type=script&lang=js&"
export * from "./UserItemPage.vue?vue&type=script&lang=js&"
import style0 from "./UserItemPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports